import {
  IsUUID,
  IsString,
  IsEnum,
  IsOptional,
} from 'class-validator';

import {
  CreateCompanyInterface,
  UpdateCompanyInterface,
} from '../../interface/companies/modify-company.interface';

import { Industry, VatType } from '../../utils/enums.utils';
import { CompanyStatus } from '../../interface/companies/company-response.interface';

export class CreateCompanyDto implements CreateCompanyInterface {

  @IsString()
  company_name!: string;

  @IsEnum(Industry)
  industry!: Industry;

  @IsEnum(VatType)
  vat_type!: VatType;

  @IsOptional()
  @IsString()
  product_service!: string | null;

  @IsOptional()
  @IsString()
  payment_terms!: string | null;

  @IsEnum(CompanyStatus)
  status!: CompanyStatus;

  @IsOptional()
  @IsString()
  address!: string | null;

  @IsOptional()
  @IsString()
  tin_number!: string | null;

  @IsString()
  customer_code!: string;

  @IsOptional()
  @IsUUID()
  created_by_id!: string | null;

  @IsOptional()
  @IsUUID()
  updated_by_id!: string | null;

  @IsOptional()
  @IsUUID()
  attachment_company_logo_id!: string | null;

  @IsOptional()
  @IsUUID()
  attachment_org_chart_id!: string | null;
}

export class UpdateCompanyDto implements UpdateCompanyInterface {

  @IsUUID()
  id!: string;

  @IsOptional()
  @IsString()
  company_name?: string | null;

  @IsOptional()
  @IsEnum(Industry)
  industry?: Industry | null;

  @IsOptional()
  @IsEnum(VatType)
  vat_type?: VatType | null;

  @IsOptional()
  @IsString()
  product_service?: string | null;

  @IsOptional()
  @IsString()
  payment_terms?: string | null;

  @IsOptional()
  @IsEnum(CompanyStatus)
  status?: CompanyStatus | null;

  @IsOptional()
  @IsString()
  address?: string | null;

  @IsOptional()
  @IsString()
  tin_number?: string | null;

  @IsOptional()
  @IsString()
  customer_code?: string | null;

  @IsUUID()
  updated_by_id!: string | null;

  @IsOptional()
  @IsUUID()
  attachment_company_logo_id?: string | null;

  @IsOptional()
  @IsUUID()
  attachment_org_chart_id?: string | null;
}